import Component from '../abstracts/Component';

export default class WishlistComponent extends Component {

  get SELECTORS() {
    return {
      citySelect: '.js-tailored-select-city',
      storesContainer: '.js-stores-container',
      storeSelect: '.js-store-selected'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      active: 'active',
      removing: 'removing'
    };
  }

  constructor() {
    super();
  }

  findStoresByTown()
  {
    $(this.SELECTORS.citySelect).on('change', function(){
      var selectedTown = $(this).val();
      var feature = $(this).data('feature');
      var url = $(this).data('url');

      console.log("Selected city: " + selectedTown + " - feature: " + feature);

      $.ajax({
        type: "GET",
        dataType: 'html',
        data: {
          'special-stores-from-town' : true,
          'selected-town' : selectedTown,
          'feature' : feature
        },
        url : url,
        cache: false,
        success: function(response)
        {
          $('.js-stores-container').html(response);
          $('.js-stores-container').children().select2();
          $('.js-store-selected').attr('required', 'true');

        },
        error: function(errorObj, textStatus, errorThrown){
          console.log("An error occurred");
        }
      });

    });
  }

  bindEvents() {
    console.log("Tailored Experience init");
    this.findStoresByTown();

    $('.js-tailored-privacy').on('click', function () {
      if($(this).is(':checked')){
        $('.js-submit').removeAttr('disabled');
      }else{
        $('.js-submit').attr('disabled', true);
      }
    })
  }

  render() {
    this.bindEvents();
  }
}
